export default __webpack_public_path__ + "static/media/IBMPlexSans-Medium.06f64402.woff";